"use client";

import { useSearchParams } from "next/navigation";
import qs from "query-string";
import { useFormState } from "react-dom";
import Button from "./button";
import InputField from "./form/input-field";

type OTPLoginProps = {
  email?: string;
  redirectUrl?: string;
  isApp: boolean;
};

const OTPLogin = (props: OTPLoginProps) => {
  const searchParams = useSearchParams();

  const [_, action] = useFormState(async (_: any, formData: FormData) => {
    const redirectUrl = props.redirectUrl || searchParams.get("redirectUrl");

    const email = formData.get("email")?.toString() || "";
    const code = formData.get("code")?.toString() || "";

    const query = qs.stringify({
      email,
      redirectUrl,
      isApp: props.isApp,
    });

    window.location.href = `/verify-token/${code}?${query}`;
  }, null);

  return (
    <form className="space-y-4" action={action}>
      <InputField
        autoFocus={Boolean(!props.email)}
        label="E-postadress"
        type="email"
        name="email"
        placeholder="Ange e-postadress"
        autoComplete="email"
        defaultValue={props.email}
        readOnly={Boolean(props.email)}
        required
      />
      <InputField
        type="text"
        label="Kod"
        required
        inputMode="numeric"
        pattern="\d*"
        minLength={6}
        maxLength={6}
        autoComplete="one-time-code"
        name="code"
        placeholder="Ange kod"
        helpText="Ange kod med 6 siffror."
        autoFocus={Boolean(props.email)}
      />

      <Button type="submit" showLoader className="w-full btn-large btn-comp">
        Fortsätt
      </Button>
    </form>
  );
};

export default OTPLogin;
